"use client"

import { useRef, useState } from "react"
import { createContainer } from "unstated-next"

const CreateCanvasContainer = createContainer(() => {
  const [canvasSize, setCanvasSize] = useState({ width: 0, height: 0 })
  const [isMasked, setIsMasked] = useState<boolean>(false)
  const canvasRef = useRef<HTMLCanvasElement>(null)

  const resetCanvas = () => {
    const canvas = canvasRef.current
    if (!canvas) return

    const ctx = canvas.getContext("2d")
    if (!ctx) return

    ctx.clearRect(0, 0, canvas.width, canvas.height)
    setIsMasked(false)
  }

  return {
    canvasRef,
    resetCanvas,
    canvasSize,
    setCanvasSize,
    isMasked,
    setIsMasked,
  }
})

export const CreateCanvasProvider = CreateCanvasContainer.Provider
export const useCreateCanvas = CreateCanvasContainer.useContainer
